export default __webpack_public_path__ + "static/media/linkedin-svgrepo-com.38e09fc1.svg";